import React from 'react';
import { useLocation } from 'react-router-dom';

interface Violation {
  type: string;
  affectedContent: string;
  date: string;
  status: string;
}

const mockViolations: Violation[] = [
  {
    type: 'Policy Non-Compliance',
    affectedContent: 'Swiss fresh.. / Crop Market',
    date: '16.02.2026',
    status: 'Under Review',
  },
  {
    type: 'Policy Non-Compliance',
    affectedContent: 'Tomatto Green.. / Crop Market',
    date: '05.02.2026',
    status: 'Warning Issued',
  },
  {
    type: 'Policy Non-Compliance',
    affectedContent: 'Wheet EU.. / Crop Market',
    date: '01.02.2026',
    status: 'Restricted',
  },
];

const NoViolations: React.FC = () => (
  <div style={styles.container}>
    {/* <div style={styles.header}>
      <span style={styles.dash}>—</span>
      <h2 style={styles.title}>Violations</h2>
    </div> */}
    <div style={styles.body}>
      <h3 style={{ ...styles.statusTitle, color: '#2e7d32' }}>No Violations Detected</h3>
      <p style={styles.text}>
        Your account is in good standing. We have not detected any policy violations.
      </p>
      <p style={styles.text}>
        Keep following Fesilah guidelines to maintain your trusted status and uninterrupted access to all features.
      </p>
      <ul style={{ paddingLeft: 0, listStyle: 'none', marginTop: 16 }}>
        <li style={styles.bulletItem}>- &nbsp;Account Status: <span style={{ color: '#2e7d32', fontWeight: 600 }}>Active</span></li>
        <li style={styles.bulletItem}>- &nbsp;No restrictions applied</li>
      </ul>
    </div>
  </div>
);

const WithViolations: React.FC<{ violations: Violation[] }> = ({ violations }) => (
  <div style={styles.container}>
    {/* <div style={styles.header}>
      <span style={styles.dash}>—</span>
      <h2 style={styles.title}>Violations</h2>
    </div> */}
    <div style={styles.body}>
      <h3 style={{ ...styles.statusTitle, color: '#c62828' }}>Policy Violations Detected</h3>
      <p style={styles.text}>
        We have identified one or more violations associated with your account. Some features may be temporarily
        restricted depending on the severity of the violation.
      </p>

      <p style={styles.sectionLabel}>What You Can Do?</p>
      <p style={styles.text}>
        Please review your content and ensure compliance with Fesilah policies.
      </p>
      <p style={styles.text}>
        If you believe this action was taken in error, you may contact us (support@fesilah.com) for clarification.
      </p>

      <p style={styles.sectionLabel}>Important Notice</p>
      <p style={styles.text}>
        Repeated violations may result in further restrictions,
      </p>

      <p style={styles.sectionLabel}>Violation Details</p>
      <div style={styles.divider} />

      {violations.map((v, i) => (
        <div key={i}>
          <div style={styles.violationRow}>
            <p style={styles.violationText}>Type of Violation: {v.type}</p>
            <p style={styles.violationText}>Affected Content: {v.affectedContent}</p>
            <p style={styles.violationText}>Date: {v.date}</p>
            <p style={styles.violationText}>Status: {v.status}</p>
          </div>
          {i < violations.length - 1 && <div style={styles.rowDivider} />}
        </div>
      ))}
    </div>
  </div>
);

const ViolationsPage: React.FC = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const hasViolations = params.get('hasViolations') === 'true';

  if (hasViolations) {
    return <WithViolations violations={mockViolations} />;
  }
  return <NoViolations />;
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    fontFamily: "'Segoe UI', Arial, sans-serif",
    backgroundColor: '#fff',
    minHeight: '100vh',
    padding: '24px 20px',
    boxSizing: 'border-box',
    maxWidth: 480,
    margin: '0 auto',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 20,
  },
  dash: {
    fontSize: 18,
    fontWeight: 700,
    color: '#111',
    marginRight: 12,
  },
  title: {
    fontSize: 16,
    fontWeight: 700,
    color: '#111',
    margin: 0,
  },
  body: {
    paddingLeft: 4,
  },
  statusTitle: {
    fontSize: 15,
    fontWeight: 700,
    marginBottom: 14,
    marginTop: 0,
  },
  text: {
    fontSize: 13,
    color: '#333',
    marginBottom: 10,
    lineHeight: 1.7,
  },
  bulletItem: {
    fontSize: 13,
    color: '#333',
    lineHeight: 1.8,
  },
  sectionLabel: {
    fontSize: 13,
    fontWeight: 700,
    color: '#111',
    marginBottom: 4,
    marginTop: 14,
  },
  divider: {
    borderBottom: '1px solid #ddd',
    marginBottom: 12,
  },
  violationRow: {
    paddingBottom: 10,
    paddingTop: 4,
  },
  violationText: {
    fontSize: 13,
    color: '#333',
    margin: '2px 0',
    lineHeight: 1.6,
  },
  rowDivider: {
    borderBottom: '1px solid #eee',
    marginBottom: 10,
  },
};

export default ViolationsPage;
